import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
// import Typography from "@material-ui/core/Typography";
// import "./Home.css";
import "./WelcomeName.css";
import Tooltip from "@mui/material/Tooltip";
import ShowAccessOnToolTip from "./UserMaintananence/ShowAccessOnToolTip";

const WelcomeName = () => {
  const { instance } = useMsal();
  const [name, setName] = useState(null);

  const activeAccount = instance.getActiveAccount();

  useEffect(() => {
    if (activeAccount) {
      setName(activeAccount.name);
    } else {
      setName(null);
    }
  }, [activeAccount]);

  if (name) {
    let temp = name.split(" ");
    let firstName = temp[temp.length - 1];
    return (
      <>
        <div className="welcome_section">
          <ShowAccessOnToolTip />
          <div class="vl"></div>
          <div>
            <Tooltip title={firstName} arrow placement="bottom">
              <div className="userName">
                Welcome {firstName}!
              </div>
            </Tooltip>

            <img
              src={process.env.PUBLIC_URL + "/Images/Avatar.png"}
              className="user-img"
              alt="user-image"
            />
          </div>
        </div>
      </>
    );
  } else {
    return null;
  }
};

export default WelcomeName;
